export const FIELD_STORAGE_PREFIX = "form-field-";

export type CanonicalLeadField =
  | "email"
  | "firstName"
  | "lastName"
  | "companySize"
  | "company"
  | "phone";

// Append-only: the lead-hint cookie encodes a positional bitmask over this
// array, so reordering or removing an entry misreads every cookie already issued.
export const CANONICAL_LEAD_FIELDS = [
  "email",
  "firstName",
  "lastName",
  "companySize",
  "company",
  "phone",
] as const satisfies readonly CanonicalLeadField[];

// Both casings are read here for storage-key lookups and to resolve fin-ai's
// PascalCase step-definition ids to the canonical field they belong to.
// Order within each pair is load-bearing: [camelCase, PascalCase].
export const FIELD_ALIASES: Record<CanonicalLeadField, readonly string[]> = {
  email: ["email", "Email"],
  firstName: ["firstName", "FirstName"],
  lastName: ["lastName", "LastName"],
  // One alias deliberately: every call site in both apps spells this
  // camelCase, so there is no PascalCase variant to resolve.
  companySize: ["numEmployeesIntercom"],
  company: ["company", "Company"],
  phone: ["phone", "Phone"],
};

export function canonicalFieldForId(
  fieldId: string,
): CanonicalLeadField | undefined {
  return CANONICAL_LEAD_FIELDS.find((field) =>
    FIELD_ALIASES[field].includes(fieldId),
  );
}
